import { useEffect } from "react";
import { Link } from "react-router-dom";
import { Header } from "../components/header/Header";
import { Footer } from "../components/footer/Footer";
import "./LegalPage.css";

export const LegalPage = ({ title, lastUpdated, children }) => {
  // Static pages should start at the top, not wherever the previous route was.
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <>
      <Header />
      <main className="legalPage">
        <div className="legalWrapper">
          <Link to="/" className="legalBack">
            &larr; Back to home
          </Link>
          <h1 className="legalTitle">{title}</h1>
          {/* {lastUpdated && (
            <p className="legalUpdated">Last updated: {lastUpdated}</p>
          )} */}
          <div className="legalContent">{children}</div>
        </div>
      </main>
      <Footer />
    </>
  );
};
